import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";

// The app runs with `ssr: false`, so there is no server state to hydrate.
export default defineNuxtPlugin({
    name: "vue-query",
    setup(nuxtApp) {
        const queryClient = new QueryClient({
            defaultOptions: {
                queries: { refetchOnWindowFocus: false, staleTime: 5000 },
            },
        });

        nuxtApp.vueApp.use(VueQueryPlugin, { queryClient });
    },
});
